import {createContext} from "react";

export const BackgroundContext = createContext(false);
